<template>
  <a-modal
    wrapClassName="customModal"
    v-model:open="open"
    title="高级设置"
    centered
    :width="660"
    destroyOnClose
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleClose">
      <div class="dialog_container">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane key="1" tab="CDN配置">
            <div class="config_textarea">
              <a-textarea
                v-model="form.cdnLayoutConfig"
                placeholder="请输入CDN配置"
                :auto-size="{ minRows: 10, maxRows: 10 }"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="回显屏配置" force-render>
            <div class="config_textarea">
              <a-textarea
                v-model="form.echoScreenConfig"
                placeholder="请输入回显屏配置"
                :auto-size="{ minRows: 10, maxRows: 10 }"
              />
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    advancedSetupOpen: {
      type: Boolean,
      default: false
    },
    advancedSettingDetail: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      open: false,
      form: {
        cdnLayoutConfig: '',
        echoScreenConfig: ''
      },
      activeKey: '1'
    }
  },
  watch: {
    advancedSetupOpen: function (newVal) {
      this.open = newVal
    },
    advancedSettingDetail: {
      handler: function (newVal) {
        Object.assign(this.form, {
          ...newVal
        })
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async handleOk () {
      try {
        const params = {
          ...this.form
        }
        const result = await this.$http.advancedSettingEdit(params)
        if (result.code !== 200) return this.$message.error('保存失败')
        const { resultStatus } = result.rt
        if (resultStatus !== 1) return this.$message.error('保存失败')
        this.$message.success('保存成功')
        Object.assign(this.form, {
          cdnLayoutConfig: '',
          echoScreenConfig: ''
        })
        this.activeKey = '1'
        this.$emit('update:advancedSetupOpen', false)
      } catch (err) {
        console.log(err)
      }
    },
    handleClose () {
      Object.assign(this.form, {
        cdnLayoutConfig: '',
        echoScreenConfig: ''
      })
      this.activeKey = '1'
      this.$emit('update:advancedSetupOpen', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  .config_textarea {
    width: 100%;
    height: auto;
    margin-bottom: 24px;
  }
}
::v-deep .ant-modal-body {
  padding: 0 16px;
  padding-top: 20px;
  border-bottom: 1px solid #e7e7e7;
}
::v-deep .ant-modal-footer {
  padding: 20px;
  border-top: none;
  text-align: center;
  .ant-btn {
    width: 108px;
    height: 38px;
    border: 1px solid #5F60D3;
    color: #5F60D3;
  }
  .ant-btn-primary {
    margin-left: 16px;
    background: #5F60D3;
    color: #fff;
  }
}
</style>